import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container error" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "error-title" }, "Intitulé de l'erreur", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "error-number" }, "404", -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "error-description" }, "Texte explicatif sur l'erreur si nécessaire", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Retour à l'accueil")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      "is-home": false,
      title: "Erreur",
      icon: "alert-circle"
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("img", {
        src: require('@/assets/error/error.svg'),
        alt: "Deux personne en panne de voiture sur l'autoroute",
        class: "error-image"
      }, null, 8, _hoisted_4),
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: "/",
        class: "error-link"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ], 64))
}